import React from 'react';
import PropTypes from 'prop-types';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import OrganisationActions from '../../actions/OrganisationActionCreator';
import OrganisationStore from '../../stores/OrganisationStore';


const OrganisationForm = React.createClass({

    getInitialState: function () {

        return {
            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),
            details: {
                id: '',
                name: '',
                description: '',
                imageHeader: '',
                isPublic: false
            },
        };
    },

    componentDidMount: function() {
        if(this.state.isEdit) {
            OrganisationStore.addChangeListener(this._onChange);
            OrganisationActions.getById(this.props.routeParams.id);
        }
    },

    componentWillUnmount: function() {
        if (this.state.isEdit) {
            OrganisationStore.removeChangeListener(this._onChange);
        }
    },

    _onSave: function (model) {
        if(!this.state.isEdit) {
            return OrganisationActions.save(model);
        } else {
            return OrganisationActions.update(this.props.routeParams.id, model);
        }
    },

    render: function () {

        const formTitle  = (!this.state.isEdit ? 'New Organisation' : this.state.details.name);
        const redirectTo = '/dashboard/organisation' + (this.state.isEdit ? '/' + this.state.details.id : 's'); // :P

        return(
            <Form
                title={formTitle}
                onSave={this._onSave}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                        <div className='cent-flex-row'>
                            <div className='cent-col-1'>
                                <TextField
                                    name="name"
                                    value={this.state.details.name}
                                    hintText="Name"
                                    floatingLabelText="Name"
                                    required
                                />
                            </div>
                            <div className='cent-col-1'>
                                <TextField
                                    name="description"
                                    value={this.state.details.description}
                                    validations="maxLength:120"
                                    validationError="Please use only numbers and letters"
                                    hintText="Description"
                                    floatingLabelText="Description"
                                />
                            </div>
                            <div className='cent-col-1'>
                            <TextField
                                name="imageHeader"
                                value={this.state.details.imageHeader}
                                validations="maxLength:120"
                                hintText="Image"
                                floatingLabelText="Image"
                            />
                            </div>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <div className='cent-checkbox-hint'>Public organisation</div>
                                    <Checkbox
                                        name="isPublic"
                                        value={this.state.details.isPublic}
                                        label="Public"
                                    />
                                </div>
                            </div>
                            {this.context.auth.isRootAdmin() && (
                                <div className='cent-col-1'>
                                    <div className='cent-checkbox-wrapper'>
                                        <Checkbox
                                            name="enabled"
                                            value={!this.state.isEdit || !!this.state.details.enabled}
                                            label="Enabled"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </CardText>
                </Card>
            </Form>
      );
    },

    _onChange: function() {
        const details = OrganisationStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({details});
        }
    }

});

OrganisationForm.contextTypes = {
    auth: PropTypes.object
};

export default OrganisationForm;

